import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SocialIcon } from "react-social-icons";
import { websiteSocialLinks } from "../utils/common.data";

const Header = ({ isAuthenticated }) => {
  const [print, setprint] = useState(false);
  const [addrressInfo, setAddrressInfo] = useState("");
  const [emailInfo, setEmailInfo] = useState("");
  const [phoneInfo, setPhoneInfo] = useState("");
  const [logoURL, setLogoURL] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleNavbar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const closeNavbar = () => {
    setIsCollapsed(true);
  };

  const navigate = useNavigate();

  useEffect(() => {
    let username = sessionStorage.getItem("phone");
    if (username === "" || username === null) {
      setprint(true);
    }
  }, []);

  return (
    <header className="tj-header">
      {/* <!--Header Content Start--> */}
      <div className="container">
        <div className="row">
          {/* <!--Toprow Content Start--> */}
          <div className="col-md-7 col-sm-6 col-xs-12 main-logo">
            <div
              className="tj-logo"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
              }}
            >
              <span>
                <img
                  className="cursor-pointer"
                  onClick={() => {
                    navigate("/");
                  }}
                  style={{
                    height: "160px",
                    margin: "auto",
                    marginTop: "20px",
                    display: "block",
                  }}
                  alt="logo"
                  src="images/logo.jpg"
                />
              </span>
              {/* <span
                className="logotext"
                style={{ fontSize: 16, fontWeight: 600, color: "#000" }}
              ></span> */}
            </div>

            {/* <!--Logo End--> */}
          </div>
          <div style={{ display: "block" }}>
            <div>
              <div id="google_translate_element"></div>
            </div>
            <span
              className="header-text"
              style={{
                position: "absolute",
                fontSize: 18,
                fontWeight: 600,
                padding: "24px 79px",
                color: "#000",
              }}
            >
              Connect with us
            </span>

            <div
              className="social-css"
              style={{
                display: "flex",
                justifyContent: "space-between",
                textAlign: "center",
                padding: "70px",
                marginTop: 15,
              }}
            >
              <span className="social-media">
                <SocialIcon
                  target="_blank"
                  url={websiteSocialLinks.facebook}
                  rel="noopener noreferrer"
                />
              </span>
              {/* <span className="social-media">
                  <SocialIcon
                    target="_blank"
                    url={websiteSocialLinks.tiktok}
                    rel="noopener noreferrer"
                  />
                </span> */}

              <span className="social-media">
                <SocialIcon
                  target="_blank"
                  url={websiteSocialLinks.linkedin}
                  rel="noopener noreferrer"
                />
              </span>

              <span className="social-media">
                <SocialIcon
                  target="_blank"
                  url={websiteSocialLinks.instagram}
                  rel="noopener noreferrer"
                />
              </span>
              <span className="social-media">
                <SocialIcon
                  target="_blank"
                  url={websiteSocialLinks.twitter}
                  rel="noopener noreferrer"
                />
              </span>

              <span className="social-media">
                <SocialIcon
                  target="_blank"
                  url={websiteSocialLinks.youtube}
                  rel="noopener noreferrer"
                />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="tj-nav-row">
        <div className="container">
          <div className="row">
            <div className="tj-nav-holder">
              <nav className="navbar navbar-default">
                <div
                  className="navbar-header"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    className="logo-mobile"
                    style={{
                      width: "40%",
                      margin: "auto",
                      marginTop: 0,
                      marginBottom: 0,
                      display: "flex",
                      justifyContent: "center",
                      paddingLeft: "18%",
                    }}
                  >
                    <img src="images/logo.jpg" height="60px" width="70px" />
                  </div>

                  <button
                    type="button"
                    className="navbar-toggle collapsed"
                    // data-toggle="collapse"
                    // data-target="#tj-navbar-collapse"
                    aria-expanded={!isCollapsed}
                    onClick={toggleNavbar}
                  >
                    <span className="sr-only">Menu</span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>
                </div>

                {/* <!-- Navigation Content Start --> */}

                <div
                  className={`collapse navbar-collapse ${
                    isCollapsed ? "" : "in"
                  }`}
                  id="tj-navbar-collapse"
                >
                  <ul className="nav navbar-nav">
                    <li className="dropdown" onClick={closeNavbar}>
                      <Link to="/">Home</Link>
                    </li>
                    <li onClick={closeNavbar}>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li onClick={closeNavbar}>
                      <Link to="/services">Services</Link>
                    </li>
                    <li onClick={closeNavbar}>
                      <Link to="/contact-us">Contact Us</Link>
                    </li>
                    {/* <li onClick={closeNavbar}>
            <Link to="/blog">Blog</Link>
          </li>
          <li onClick={closeNavbar}>
            <Link to="/article">Article</Link>
          </li>
          <li onClick={closeNavbar}>
            <Link to="/announcement">Announcement</Link>
          </li> */}
                    {!isAuthenticated ? (
                      <li onClick={closeNavbar}>
                        <Link to="/login">Login</Link>
                      </li>
                    ) : (
                      <li onClick={closeNavbar}>
                        <Link to="/profile">My Account</Link>
                      </li>
                    )}
                    <li
                      onClick={closeNavbar}
                      className="header_mobile_dropdown_btn"
                    >
                      <Link to="/booknow">Book Now</Link>
                    </li>
                  </ul>
                </div>
                {/* <!-- Navigation Content Start --> */}
              </nav>
              {/* <!--Menu Holder End--> */}
              <div className="book_btn">
                <Link to="/booknow">
                  Book Now{" "}
                  <i
                    className="fa fa-arrow-circle-right"
                    aria-hidden="true"
                  ></i>
                </Link>
              </div>
            </div>
            {/*<!--Nav Holder End--> */}
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header;
